module.exports = __webpack_public_path__ + "static/media/49.bea5c832.jpg";